import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-whatsnew',
    templateUrl: './whatsnew.component.html',
    styleUrls: ['./whatsnew.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WhatsnewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    
  }

}
